const routes = [
  {
    label: 'Glavni meni',
    labelDisable: true,
    children: [
      {
        name: 'Dashboard',
        icon: 'chart-pie',
        to: '/dashboard',
        exact: true
      }
    ]
  },
  {
    label: 'Magacin',
    children: [
      {
        name: 'Dokumenti',
        icon: 'file-alt',
        to: '/documents'
      },
      {
        name: 'Lokacije',
        icon: 'map-marker-alt',
        to: '/locations'
      },
      {
        name: 'Proizvodi',
        icon: 'boxes',
        to: '/products'
      },
      {
        name: 'LPN-ovi',
        icon: 'layer-group',
        to: '/lpns'
      }
    ]
  },
  {
    label: 'Administracija',
    children: [
      {
        name: 'Korisnici',
        icon: 'users',
        to: '/users'
      }
    ]
  }
];

export const dashboardRoutes = { label: '', children: [] };
export const appRoutes = { label: '', children: [] };
export const pagesRoutes = { label: '', children: [] };
export const modulesRoutes = { label: '', children: [] };
export const documentationRoutes = { label: '', children: [] };

export default routes;
